var URLS;
(function (URLS) {
    URLS["ACHIEVEMENTS"] = "achievements-service/v1/achievements";
    URLS["FLAGS_LIST"] = "sport-info/v1/categories/flags";
    URLS["CATEGORY_BY_ID"] = "sport-events/v1/outrights/category/$id";
    URLS["MAIN_COLUMNS_INFO"] = "sport-info/v1/markets/maincolumns";
    URLS["TOP_UP_LIMITS"] = "/v2/player-games/topup-limits";
    URLS["PAYMENTS_LIMITS"] = "payment-service/v1/payments/limits";
    URLS["GAME_BALANCE"] = "/v2/player-games/accounts/balance-request";
    URLS["CONVERSION_TEASERS"] = "/content/v1/conversion-teasers";
})(URLS || (URLS = {}));
export { URLS };
